<template>
    <Card>
        <Row :gutter="16">
            <Col span="24">
            <div class="global-tool-bar">
                <div class="left-bar">
                    <span class="title">会员资金明细</span>
                </div>
                <div class="right-bar" />
            </div>
            </Col>
        </Row>

        <Form label-position="top">

            <Row :gutter="16">
                <Col span="6">
                <FormItem label="绑定会员">
                    <Input :value="userPersonName"
                        readonly></Input>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="16">
                <Col span="24">
                <div>资金明细</div>
                <stand-pagination-table :columns="mainTable.tableColumns"
                    :data="mainTable.tableData"
                    :loading="mainTable.tableLoading"
                    :table-search="mainTable.tableSearch"
                    :table-load-event="getMainTableRecords" />
                </Col>
            </Row>
        </Form>
    </Card>
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import CurrencyInput from '@/components/number-input/currency-input';
import { number2ThousandsFormat } from '@/components/number-input/display-format';
import { formatDateTimeString } from '@/libs/logic';
import { singleImageRender } from '@/libs/tableRowImageRender';

import { getMemberFundRecord } from '@/api/modules/finance-management/member-fund';

export default {
    name: 'MemberFundDetail',
    components: {
        CurrencyInput,
        StandPaginationTable
    },
    data() {
        return {
            userUuid: '',
            userPersonName: '',
            pageSizeOpts: search.getSizeConfig(),
            mainTable: {
                tableColumns: [
                    {
                        title: '操作日期',
                        key: 'memberFundRecordCreateAt',
                        align: 'center',
                        render: (h, params) => {
                            return h('span', {}, formatDateTimeString(params.row.memberFundRecordCreateAt));
                        }
                    },
                    {
                        title: '汇入金额',
                        key: 'memberFundRecordInFlow',
                        align: 'center',
                        render: (h, params) => {
                            const inFlow = params.row.memberFundRecordInFlow ? params.row.memberFundRecordInFlow : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(inFlow, 2, '￥'))
                            ]);
                        }
                    },
                    { title: '凭证', align: 'center', render: (h, params) => singleImageRender(h, params.row.memberFundRecordInFlowFile) },
                    {
                        title: '消费金额',
                        key: 'memberFundRecordConsume',
                        align: 'center',
                        render: (h, params) => {
                            const consume = params.row.memberFundRecordConsume ? params.row.memberFundRecordConsume : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(consume, 2, '￥'))
                            ]);
                        }
                    },
                    {
                        title: '帐户余额',
                        key: 'memberFundRecordBalance',
                        align: 'center',
                        render: (h, params) => {
                            const balance = params.row.memberFundRecordBalance ? params.row.memberFundRecordBalance : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(balance, 2, '￥'))
                            ]);
                        }
                    },
                    {
                        title: '定金余额',
                        key: 'memberFundRecordBalance',
                        align: 'center',
                        render: (h, params) => {
                            const balance = params.row.memberFundRecordDepositBalance ? params.row.memberFundRecordDepositBalance : 0;
                            return h('div', {}, [
                                h('span', {}, number2ThousandsFormat(balance, 2, '￥'))
                            ]);
                        }
                    },
                    { title: '备注', key: 'memberFundRecordRemark', align: 'center' },
                    { title: '经办人', key: 'memberFundRecordOperatorName', align: 'center' }
                ],
                tableData: [],
                tableLoading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const query = this.$route.query;
            if (query.userUuid) {
                this.userUuid = query.userUuid;
                this.userPersonName = query.userPersonName;
                this.getMainTableRecords();
            }
        },
        getMainTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            const condition = Object.assign({ userUuid: this.userUuid }, this.mainTable.tableSearch);

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getMemberFundRecord(condition).then(res => {
                if (res.code === 0) {
                    this.mainTable.tableData = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            });
        }
    }
};
</script>

<style scoped>
</style>
